import React, { useState } from 'react'
import {
  Flex,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  PopoverFooter,
  Button,
} from '@chakra-ui/react'

import { Trash } from 'components/icons'
import { MessageCenterRoutes } from 'components/tools/MessageCenterChat/types'
import { useMessageCenterChatManager } from 'components/tools/MessageCenterChat/contexts/MessageCenterChatManager/Provider'
import { MessageCenterMessageCardActionsProps } from '../..'

type Props = MessageCenterMessageCardActionsProps & {
  routes: MessageCenterRoutes
}

export default function MessageCenterDeleteMessage({ message, setMenuPosition, routes }: Props) {
  const [loadingDeleteMessage, setLoadingDeleteMessage] = useState<boolean>(false)

  const { messages, setMessages } = useMessageCenterChatManager()

  async function handleDeleteMessage() {
    setLoadingDeleteMessage(true)
    const response = await routes.deleteMessage(message)
    if (response?.header?.success) {
      const updatedMessages = messages.filter((messageItem) => messageItem.id !== message.id)
      setMessages(updatedMessages)
      setMenuPosition(null)
    }
    setLoadingDeleteMessage(false)
  }

  return (
    <Popover>
      {({ onClose }) => (
        <>
          <PopoverTrigger>
            <Flex align="center" p={2} gap={2} className="accessible" _hover={{ bg: 'primary', color: 'light' }}>
              <Trash />
              <Text>Apagar</Text>
            </Flex>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverHeader color="dark">Deseja deletar a mensagem?</PopoverHeader>
            <PopoverArrow />
            <PopoverCloseButton bg="primary" />
            <PopoverBody>
              <Text color="dark">Ao deletar a mensagem não poderá voltar atrás</Text>
            </PopoverBody>
            <PopoverFooter>
              <Flex align="center" gap={2}>
                <Button variant="outline" minWidth="50%" onClick={onClose}>
                  Fechar
                </Button>
                <Button
                  isLoading={loadingDeleteMessage}
                  colorScheme="red"
                  minWidth="50%"
                  onClick={async () => {
                    await handleDeleteMessage()
                    onClose()
                  }}
                >
                  Deletar
                </Button>
              </Flex>
            </PopoverFooter>
          </PopoverContent>
        </>
      )}
    </Popover>
  )
}
